/** @flow */
import * as Paths from "@routes/constants";

export const USER_TYPES = {
  ADMIN: "ADMIN",

  // Operating company types
  ABSENCE_ADVISOR: "ABSENCE_ADVISOR",
  NURSE_ADVISOR: "NURSE_ADVISOR",
  LEAD_NURSE_ADVISOR: "LEAD_NURSE_ADVISOR",
  CONTACT_CENTRE_MANAGER: "CONTACT_CENTRE_MANAGER",
  SERVICE_MANAGER: "SERVICE_MANAGER",
  TEXT_TO_CLOSE_SERVICE: "TEXT_TO_CLOSE_SERVICE",

  /* Client Types */
  EMPLOYEE: "EMPLOYEE",
  MANAGER: "MANAGER",
  ADVANCED_USER: "ADVANCED_USER",
  FULL_HR_ACCESS: "FULL_HR_ACCESS",
  CLIENT_ADMIN: "CLIENT_ADMIN",
  CLIENT_DATA_TRANSFER: "CLIENT_DATA_TRANSFER",
  CLIENT_TREND_VIEWER: "CLIENT_TREND_VIEWER",
  CLIENT_SUPPLIER: "CLIENT_SUPPLIER",
  DEVELOPER: "DEVELOPER",
  THIRD_PARTY_APPLICATION: "THIRD_PARTY_APPLICATION",
};
